import styled from 'styled-components'

import { giphyLightestGrey } from '@/styles/colors'

export default styled.hr`
  height: 1px;
  border: none;
  color: ${giphyLightestGrey};
  background-color: ${giphyLightestGrey};
  margin: 100px 0 90px 0;
`
